export default function SectionHeader({ eyebrow, title, description, align = "left", className = "" }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}
      data-testid="section-header"
    >
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A1F44] mt-3 leading-[1.05]">
        {title}
      </h2>
      {description && (
        <p className="text-base md:text-lg text-slate-600 mt-5 leading-relaxed">{description}</p>
      )}
    </div>
  );
}
